// INSTANCES
export const SELECT_INSTANCES = 'on-select-instances';

// LISTS
export const GERMPLASM_LIST_CREATED = 'on-germplasm-list-created';
export const TREE_STATE_PERSISTED = 'on-tree-state-persisted';

// ADVANCE
export const ADVANCE_SUCCESS = 'on-advance-finished-successfully';
